export const dreList = [
  { value: 'Receita', label: 'Receita' },
  { value: 'Impostos', label: 'Impostos' },
  { value: 'Custo Operacional', label: 'Custo Operacional' },
  { value: 'Despesas', label: 'Despesas' },
  { value: 'Receitas/Despesas Financeiras', label: 'Receitas/Despesas Financeiras' },
]